(function ($, once) {
  'use strict';
  Drupal.behaviors.tnFallColorsMap = {
    attach: function (context, settings) {
      $(once('tnFallColorsMap', '.block-tn-fall-colors-map:not(.processed)')).each(function () {
        $(this).addClass('processed');
        $(this).on('click', function () {
          $('.map-overlay', context).hide();
        });
      });
    }
  };

})(jQuery, once); // eslint-disable-line no-undef
